export default "__VITE_PUBLIC_ASSET__312db1b4__"